import { createBrowserHistory } from 'history';
import { createReduxHistoryContext } from 'redux-first-history';
import { persistStore, persistReducer } from 'redux-persist';
import { createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk';
import storage from 'redux-persist/lib/storage/session';
import createRootReducer from './reducers';

const { createReduxHistory, routerMiddleware, routerReducer } = createReduxHistoryContext({ 
  history: createBrowserHistory(),
})

const persistConfig = {
  key: 'root',
  blacklist: ['router'],
  storage
}

const persistedReducer = persistReducer(
  persistConfig,
  createRootReducer(routerReducer)
);

const store = createStore(
  persistedReducer,
  composeWithDevTools(
    applyMiddleware(routerMiddleware),
    applyMiddleware(thunk),
  )
)

const persister = persistStore(store, {}, (...args) => {});

const history = createReduxHistory(store);

export { store, persister, history };
